import { Layout, PageHeader, UnvButton, Card, Badge, Icon } from 'components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './AccountingPage.module.scss'

import { useDispatch, useSelector } from 'react-redux'

import { useLocation, useNavigate } from 'react-router-dom'

import ReceiptsContent from './components/ReceiptsContent';
import ExpensesContent from './components/ExpensesContent';
import StudentsContent from './components/StudentContent/StudentsContent';
import EmployeeContent from './components/EmployeeContent/EmployeeContent';
import ContractAmountContent from './components/ContractAmountContent';
import AccountingPageStruct from './AccountingPageStruct';

import { getAccountingDetailData, getCheckData } from "service/AccountingService";

import userInfo from 'utils/userInfo'
const AccountingDataPage = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const sections = [
    { key: "receipts", label: t('auto.accountingdata.receipts', 'Поступления'), Component: ReceiptsContent },
    { key: "expenses", label: t('auto.accountingdata.expenses', 'Расходы'), Component: ExpensesContent },
    { key: "students", label: t('auto.accountingdata.students', 'Обучающиеся'), Component: StudentsContent },
    { key: "employee", label: t('auto.accountingdata.employee', 'Сотрудники'), Component: EmployeeContent },
    { key: "contractamount", label: t('auto.accountingdata.contracts', 'Суммы контракта'), Component: ContractAmountContent },
    { key: "administration", label: t('auto.accountingdata.administration', 'Администрирование'), Component: AccountingPageStruct },

  ];

  const [activeSection, setActiveSection] = useState(null);

  const handleShowSection = (key) => {
    setActiveSection(prev => (prev === key ? null : key));
  };


  const [render, setRender] = useState(false)
  const location = useLocation()
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [datacheck, setDataCheck] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getAccountingDetailData(id, data);
      let responsecheck = await getCheckData(id, data);
      setData(response.data);
      setDataCheck(responsecheck.data);

    } catch (error) {
    }
  };

  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/accounting");
    }


  }, [render, location.pathname, location.state]);

  return (
    <Layout>
      <div className={styles.project__container}>
        <div className={styles.project__wrapper}>
          <PageHeader
            icon={<Icon name="dollar" size={28} />}
            title={data.fund_name || t('auto.accountingdata.title', 'Фонд')}
            subtitle={t('auto.accountingdata.subtitle', 'Бухгалтерия — детальная информация по фонду')}
            actions={
              <UnvButton variant="ghost" iconLeft="arrow-left" onClick={() => navigate('/accounting/')}>
                {t('common.back')}
              </UnvButton>
            }
          />
          <Card padding="md" style={{ marginBottom: 16 }}>
            <Card.Body>
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                <Badge variant="info">{t('auto.accountingdata.balance', 'Остаток')}: {data.balance}</Badge>
                <Badge variant="success">{t('auto.accountingdata.income', 'Поступления')}: {data.total_income}</Badge>
                <Badge variant="danger">{t('auto.accountingdata.expense', 'Расходы')}: {data.total_expense}</Badge>
              </div>
            </Card.Body>
          </Card>
          
          <div className={styles.project__body}>
            <div className={styles.project__menu}>
              {sections.map(({ key, label }) => (
                <div key={key} className={
                  activeSection === key
                    ? styles.project__menu__item__active
                    : styles.project__menu__item
                }>
                  <h2
                    onClick={() =>
                      handleShowSection(activeSection === key ? null : key)
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    {label} <Icon name={activeSection === key ? 'chevronUp' : 'chevronDown'} />
                  </h2>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.project__body}>
            {sections.map(({ key, Component }) =>
              activeSection === key && Component ? (
                <Component
                  key={key}
                  render={render}
                  setRender={setRender}
                  datacheck={datacheck}
                  id={id}
                />
              ) : null
            )}
          </div>
        </div>
      </div>

    </Layout>
  )
}

export default AccountingDataPage
